import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'zignal-landscape/lib/Modal';
import ModalHeader from 'zignal-landscape/lib/ModalHeader';
import ModalBody from 'zignal-landscape/lib/ModalBody';
import ModalFooter from 'zignal-landscape/lib/ModalFooter';
import Button from 'zignal-landscape/lib/Button';
import Input from 'zignal-landscape/lib/Input';
import Label from 'zignal-landscape/lib/Label';
import ErrorMessage from 'zignal-landscape/lib/ErrorMessage';

const CODE_LENGTH = 6;

const VerifyPhoneModal = ({ isOpen, phone, isSending, isChecking, error, onSubmitCode, onResend, onClose }) => {
  const [code, setCode] = useState('');

  useEffect(() => { if (!isOpen) { setCode(''); } }, [isOpen]);

  const busy = isSending || isChecking;
  const canSubmit = code.length === CODE_LENGTH && !busy;

  return (
    <Modal isOpen={isOpen} size="small" onEscapePress={onClose} onBackdropClick={onClose}>
      <ModalHeader hideCloseButton={false} onClose={onClose}>Verify your phone number</ModalHeader>
      <ModalBody>
        <p>We sent a code to {phone}. Enter it below to receive SMS notifications.</p>
        <Label htmlFor="verify-phone-code">Verification code</Label>
        <Input
          id="verify-phone-code"
          data-cy="verify-phone-code"
          inputMode="numeric"
          value={code}
          disabled={busy}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, CODE_LENGTH))}
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </ModalBody>
      <ModalFooter>
        <Button buttonStyle="positive" data-cy="verify-phone-submit" disabled={!canSubmit} onClick={() => onSubmitCode(code)}>
          {isChecking ? 'Verifying...' : 'Verify'}
        </Button>
        <Button buttonStyle="secondary" data-cy="verify-phone-resend" disabled={isSending} onClick={onResend}>
          {isSending ? 'Sending...' : 'Resend code'}
        </Button>
        <Button buttonStyle="secondary" data-cy="verify-phone-cancel" onClick={onClose}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

VerifyPhoneModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  phone: PropTypes.string,
  isSending: PropTypes.bool,
  isChecking: PropTypes.bool,
  error: PropTypes.string,
  onSubmitCode: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default VerifyPhoneModal;
